module.exports = __webpack_public_path__ + "media/images/phone/writer-offering-short-scenario-selection-flow-f43a99cf268d8bb25f8bfbb2a5a69871.png";